import React, { useEffect } from 'react';

type UseOnClickOutsideType = (
    ref: React.MutableRefObject<HTMLDivElement> | null,
    handler: (event: React.MouseEvent) => void
) => void;

const useOnClickOutside: UseOnClickOutsideType = (ref, handler) => {
    useEffect(() => {
        const listener = (event: MouseEvent) => {
            if (!ref.current || ref.current.contains(event.target as Node)) {
                return;
            }
            handler(event as unknown as React.MouseEvent);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);

        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
};

export default useOnClickOutside;
